const otp = {
  EN: {
    backward: 'back',
    email_title: 'Verify email',
    phone_title: 'Verify phone number',
    paragraph: 'We have just sent a verification code to',
    email: 'Email',
    ref: 'Ref',
    sendagain_btn: 'Send the code again',
    submit_btn: 'Submit',
    signup_btn: 'Sign up',
    otp_failed: 'Incorrect code OTP, please try again',
  },
  TH: {
    backward: 'ย้อนกลับ',
    email_title: 'ยืนยันอีเมล',
    phone_title: 'ยืนยันเบอร์โทรศัพท์',
    paragraph: 'ระบบได้ทำการส่งรหัสความปลอดภัยไปที่',
    email: 'อีเมล',
    ref: 'รหัสอ้างอิง',
    sendagain_btn: 'ส่งรหัสผ่านใหม่อีกครั้ง',
    submit_btn: 'ยืนยัน',
    signup_btn: 'สมัครสมาชิก',
    otp_failed: 'รหัส OTP ไม่ถูกต้อง, โปรดกรอกรหัส OTP ใหม่',
  },
};

export default otp;
